import { useUiStore } from "@/stores/ui-store";
import { SIDEBAR_TABS } from "@/lib/routes-meta";
import { cn } from "@/lib/utils";

interface SidebarTabBarProps {
  collapsed: boolean;
}

export function SidebarTabBar({ collapsed }: SidebarTabBarProps) {
  const activeTab = useUiStore((s) => s.activeTab);
  const setActiveTab = useUiStore.getState().setActiveTab;

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-1 border-b border-sidebar-border py-2 px-1">
        {SIDEBAR_TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              title={tab.label}
              className={cn(
                "flex items-center justify-center w-10 h-10 rounded-lg transition-colors duration-fast",
                isActive
                  ? "bg-sidebar-accent text-[hsl(var(--sidebar-active-accent))]"
                  : "text-[hsl(var(--sidebar-muted))]/60 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground",
              )}
            >
              <Icon className="h-4 w-4" />
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex items-center border-b border-sidebar-border px-2 py-1.5 gap-0.5">
      {SIDEBAR_TABS.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              "flex-1 flex flex-col items-center gap-0.5 rounded-lg px-1 py-1.5 transition-colors duration-fast",
              isActive
                ? "bg-sidebar-accent text-[hsl(var(--sidebar-active-accent))]"
                : "text-[hsl(var(--sidebar-muted))]/60 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            <span className="text-[10px] font-medium leading-none truncate">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}
